import * as THREE from 'three';
import { Subject } from 'rxjs';

export class NewTimedObject3D extends THREE.Object3D {
  timerID: any;

  readonly changes$ = new Subject<'activate' | 'change' | 'deactivate'>();

  /**
   * A Object3D that exsists for a certain amount of time in milliseconds. -1 is infinite.
   */
  constructor(private duration: number) {
    super();
  }

  /**
   * Overridable.
   * NOTE: Remember to call super.update() on the end of your function!
   */
  update(_dt?: number): void {
    this.changes$.next('change');
  }

  /**
   * Activates the timed 3D Object
   * @param durationMS - number - Time in milliseconds object should exist. Use -1 to disable timed removal.
   */
  activate(durationMS?: number): void {
    this.setRemoveTimer(durationMS);
    this.changes$.next('activate');
  }

  /**
   * Deactivates the timed 3D Object
   */
  deactivate(): void {
    this.removeFromParent();
    this.changes$.next('deactivate');
  }

  private setRemoveTimer(durationMS: number): void {
    this.duration = durationMS;

    if (this.timerID) {
      clearTimeout(this.timerID);
    }

    // If any legal value, set timer, object should last forever if less than 0.
    if (this.duration > 0) {
      this.timerID = setTimeout(() => {
        clearTimeout(this.timerID);
        this.deactivate();
      }, durationMS);
    }
  }
}
